/**
 * Initiales affichables d'une personne.
 *
 * Deux mots au plus, premier caractère de chaque : « Mathieu Consol » donne
 * « MC ». Un seul mot en donne une seule. Les séparateurs usuels d'un e-mail
 * (point, tiret, underscore) comptent comme des espaces, pour qu'une adresse
 * sans nom déclaré ne laisse pas un badge vide.
 *
 * Les chiffres et la ponctuation sont ignorés : « 2e Jean » ne doit pas donner
 * « 2J ».
 */
export function initialsOf(source: string): string {
  const parts = source
    .trim()
    .split(/[\s.'’_\-@]+/)
    .filter((word) => /^\p{Letter}/u.test(word));

  if (parts.length === 0) {
    return '?';
  }

  return parts
    .slice(0, 2)
    .map((word) => word[0]!.toLocaleUpperCase('fr-FR'))
    .join('');
}
